import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search',
  standalone: true
})
export class SearchPipe implements PipeTransform {
  transform(items: any[], searchText: string, keys: string[]): any[] {
    if (!items || !searchText || !keys || keys.length === 0) {
      return items;
    }

    return items.filter(item => {
      return keys.some(key => {
        if (item[key] && typeof item[key] === 'string') {
          return item[key].toLowerCase().includes(searchText.toLowerCase());
        }
        return false;
      });
    });
  }
}



